// extracted by mini-css-extract-plugin
export default {"network":"styles_network__KNTwL"};